import { IndexedBox } from "@opendaw/lib-box";
import { clamp, isDefined } from "@opendaw/lib-std";
import { Facade, Props } from "../Common";
export class EffectFacade extends Facade {
    constructor(context, box) {
        super(context, box);
        this.bind({ label: box.label, enabled: box.enabled, minimized: box.minimized });
    }
    get index() { return this.box.index.getValue(); }
    get hostField() { return this.box.host.targetVertex.unwrap("effect has no host"); }
    move(index) {
        this.context.edit(() => {
            const boxes = IndexedBox.collectIndexedBoxes(this.hostField).filter(box => box !== this.box);
            const at = clamp(Math.round(index), 0, boxes.length);
            const ordered = [...boxes.slice(0, at), this.box, ...boxes.slice(at)];
            ordered.forEach((box, index) => box.index.setValue(index));
        });
    }
    remove() {
        this.context.edit(() => {
            const field = this.hostField;
            const index = this.index;
            IndexedBox.removeOrder(field, index);
            this.box.delete();
        });
    }
}
export class EffectChain {
    #context;
    #field;
    #wrap;
    constructor(context, field, wrap) {
        this.#context = context;
        this.#field = field;
        this.#wrap = wrap;
    }
    list() {
        return IndexedBox.collectIndexedBoxes(this.#field).map(box => this.#wrap(box));
    }
    add(create, props, index) {
        return this.#context.edit(() => {
            const at = IndexedBox.insertOrder(this.#field, isDefined(index) ? Math.round(index) : Number.MAX_SAFE_INTEGER);
            const facade = this.#wrap(create(at));
            Props.apply(facade, props);
            return facade;
        });
    }
}
